const API_URL = "https://back.sarani.studio";

export default API_URL;
